import { request } from '@/util/http'

export const getEcgMeterData = (wxUserId) => {
  return request({
    url: '/health/ecgNew/getEcgMeterData',
    method: 'get',
    params: {
      wxUserId
    }
  })
}

